import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const SentenceElementBiled = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 100 30",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 12),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeMiterlimit: 1.5,
    strokeWidth: "2",
    children: /*#__PURE__*/jsx("path", {
      d: "M4 26c8-7 15.5-22.998 18-22.998S15.667 26 19 26 38.833 3.002 42 3.002C45.167 3.002 34.5 26 38 26S59.667 3.002 63 3.002C66.333 3.002 54.833 26 58 26S78.667 3.351 82 3.002c3.333-.348-6.333 20.907-4 20.907S92 14 96 3.002"
    })
  });
};

export { SentenceElementBiled };
//# sourceMappingURL=sentence-element.biled.js.map
